import { useEffect } from 'react';

/** The shell tags its scrolling content container with this attribute. */
export const CONTENT_SCROLL_ATTR = 'data-app-content-scroll';

/**
 * Lets the page behind an open panel keep scrolling while still blocking clicks.
 *
 * The panel's mask covers the viewport and captures the wheel, so scrolling over the content would
 * otherwise do nothing. This forwards wheel events that land on the mask — but not on the panel
 * itself — to the shell's content scroller. Clicks are untouched, so the mask still blocks them.
 */
export const useScrollBehindPanel = (visible: boolean) => {
  useEffect(() => {
    if (!visible) return;

    const onWheel = (e: WheelEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target?.closest?.('.p-sidebar-mask')) return;
      // Inside the panel itself the wheel belongs to the panel.
      if (target.closest('.p-sidebar')) return;

      const scroller = document.querySelector<HTMLElement>(`[${CONTENT_SCROLL_ATTR}]`);
      if (!scroller) return;
      scroller.scrollTop += e.deltaY;
      e.preventDefault();
    };

    window.addEventListener('wheel', onWheel, { passive: false, capture: true });
    return () => window.removeEventListener('wheel', onWheel, { capture: true } as EventListenerOptions);
  }, [visible]);
};

export default useScrollBehindPanel;
